<sh-button
    [color]="type"
    (click)="clicked($event)"
    size="max-content"
    [label]="translate ? (text | translate) : text"
/>
